import { COUNTRIES_CODES } from '@wix/forms-common/dist/src/locale-dataset/country-codes';
export const COUNTRIES_CODES_LIST = objectToSortedArray(COUNTRIES_CODES);
export function objectToSortedArray(obj) {
    return Object.keys(obj)
        .reduce((acc, key) => {
        acc.push({
            key: key,
            value: obj[key],
        });
        return acc;
    }, [])
        .sort((c1, c2) => {
        const k1 = c1.key;
        const k2 = c2.key;
        if (k1 < k2) {
            return -1;
        }
        if (k1 > k2) {
            return 1;
        }
        return 0;
    });
}
//# sourceMappingURL=utils.js.map